module.exports = __webpack_public_path__ + "static/media/asagi-eyes-open.d3287d6b.png";